import { useStaticQuery, graphql } from 'gatsby';

export const useSiteConfig = () => {
  const data = useStaticQuery(graphql`
    query SiteConfig {
      contentfulConfig(name: { eq: "config" }) {
        title
        logo {
          description
          file {
            url
          }
        }
        logoMobile {
          description
          file {
            url
          }
        }
        twitterHandle
        siblingSiteName
        siblingSiteUrl
        footer {
          ...FooterFragment
        }
        alertBanner {
          ...AlertBannerFragment
        }
        informationBanner {
          ...InformationBannerFragment
        }
        mediaContactDetails {
          ...MediaContactDetailsFragment
        }
        email
        linkedIn
        twitter
        facebook
        defaultMetaImage {
          ...ImageFragment
        }
        instagram
        tiktok
        noResultsFoundLinks {
          ...LinkBoxFragment
        }
        noResultsFoundCta {
          ...ctaStandardFragment
        }
      }
    }
  `);

  return data.contentfulConfig;
};
